import { createContext } from 'react'

const PrimaryBannerPreviewContext = createContext()

export default PrimaryBannerPreviewContext
